import { render, staticRenderFns } from "./MainNavigationShipperUi.vue?vue&type=template&id=0ebe24bb&"
import script from "./MainNavigationShipperUi.vue?vue&type=script&lang=js&"
export * from "./MainNavigationShipperUi.vue?vue&type=script&lang=js&"
import style0 from "./MainNavigationShipperUi.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports